<template>
  <el-card shadow="never" :body-style="{ padding: '0px' }">
    <div slot="header" class="toolbar">
      <h1>商务代表</h1>
      <el-link v-action="'/api/System/Customer/SaveMan'" type="primary" icon="el-icon-circle-plus" @click="onBinding()" />
    </div>
    <el-scrollbar>
      <ul>
        <li v-for="item in mans" :key="item.UserId">
          <el-link v-action="'/api/System/Customer/DeleteMan'" type="danger" icon="el-icon-delete" @click="onUnbound(item)" />
          <label style="flex: 1">{{ item.Name }}_{{ item.Phone }}</label>
          <label>{{ item.Account }}</label>
        </li>
      </ul>
    </el-scrollbar>
  </el-card>
</template>

<script>
export default {
  data () {
    return {
      phone: null,
      mans: []
    }
  },
  props: {
    customer: { type: String, require: true }
  },
  created () {
    this.loadData()
  },
  methods: {
    //获取账户列表
    loadData () {
      this.$apis.organize.customer.man.list({
        customer: this.customer
      }).then((res) => {
        this.mans = res
      }).catch((e) => {
        this.$message.error(e)
      })
    },
    //绑定
    onBinding () {
      this.$prompt('通过手机号查询系统用户，并授权为客户代表', '客户代表', {
        center: true
      }).then(({ value }) => {
        this.$apis.organize.customer.man.insert({
          phone: value,
          customer: this.customer
        }).then(() => {
          this.loadData()
        }).catch((e) => {
          this.$message.error(e)
        })
      })


    },
    //解绑
    onUnbound (row) {
      this.$confirm("此操作将永久删除数据不可恢复, 是否继续?", `删除 ${row.Name}`, {
        center: true,
      }).then(() => {
        this.$apis.organize.customer.man.delete({
          UserId: row.UserId,
          CustomerId: this.customer
        }).then(() => {
          this.loadData()
        }).catch((e) => {
          this.$message.error(e)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  padding: 10px;
  li {
    list-style: none;
    display: flex;
    align-items: center;
    padding: 10px;
    .el-link {
      font-size: 16px;
      margin-right: 10px;
    }
  }
}
</style>
